import { useQuery } from "@tanstack/react-query";
import { boronClient } from "../../api";
import { createError, HTTPErrors } from "../../errors";
import { SectionOperatorInvitationInterface } from "../../interfaces/SectionOperatorInvitationInterface";

/**
 * フックは招待情報を取得するためのものです
 * @param invitationId 招待ID
 * @param enabled クエリを有効にするかどうか。デフォルトはtrue
 */
export const useFetchInvitation = (invitationId: string) => {
  return useQuery<SectionOperatorInvitationInterface, HTTPErrors>({
    queryKey: ["invitations", invitationId],
    queryFn: async () => {
      const { response, data } = await boronClient.GET(
        "/api/v1/invitations/{invitation_hashid}",
        {
          params: {
            path: {
              invitation_hashid: invitationId,
            },
          },
        },
      );

      if (response.ok && data) {
        return data.sectionOperatorInvitation;
      }
      throw await createError(response);
    },
  });
};
